/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import "./src/style/style.scss";
import "bulma-carousel/dist/css/bulma-carousel.min.css";

export const onClientEntry = () => {
    const rootElement = document.documentElement;
    rootElement.setAttribute("data-theme", "light");
};
